import {
  todayData,
  weeklyData,
  monthlyData,
  mainTestData,
  testData,
} from "@/data/dummy";
import { ImgBanner } from "@/components/atoms/ImgBanner";
import { ImgPostItem } from "@/components/atoms/Items/ImgPostItem";
import { MainPostItem } from "@/components/atoms/Items/MainPostItem";
import { TestItem } from "@/components/atoms/Items/TestItem";
import { List } from "@/components/molecules/List";
import { ContentBox } from "@/components/molecules/ContentBox";
import { MainBanner } from "@/components/molecules/MainBanner";
import { MainPostTab } from "@/components/molecules/MainPostTab";
import { ContentSection } from "@/components/organisms/ContentSection";
import { MainTemplate } from "@/components/templates/MainTemplate";

import ImgBottom from "@/styles/assets/img/img_main.png";
import { useState, useEffect } from "react";
import {
  DIAGNOSTIC_MAIN_DATA,
  PARENTING_INFO_COUNSEL_RECENT,
  USER_CHILD_PROFILE_SELECTED,
} from "@/lib/querykeys";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { request } from "@/lib/api";
import { ResponseType } from "@/types/response.types";
import { useSelectedProfile } from "@/lib/useQuery-memo";
import { ParentingCounselType } from "@/types/community.types";
import { useNavigate } from "react-router-dom";

export interface DiagnosticMainData {
  profileId: string | null;
  age: string | null;
}

export type RangeType = "today" | "week" | "month";

export const MainPage = () => {
  const navigate = useNavigate();
  /** ============================= state 영역 ============================= */
  const [diagnosticData, setDiagnosticData] = useState<any[]>([]);
  // 육아 인기글 범위 상태
  const [range, setRange] = useState<RangeType>("today");

  /** ============================= API 영역 ============================= */
  const { data: selectedProfile } = useSelectedProfile();

  console.log("range", range);
  const { mutateAsync: diagnosticMainData } = useMutation(
    [DIAGNOSTIC_MAIN_DATA],
    async (data: DiagnosticMainData) => {
      const response = await request<ResponseType<any>>({
        method: "POST",
        url: "/diagnostic-test/main",
        data,
      });

      return response;
    },
    {
      onSuccess(data?: ResponseType<any[]>) {
        setDiagnosticData(data?.data || []);
      },
      onError(error: any) {
        console.error("Query Error:", error);
      },
    }
  );

  /** 육아상담 최근 5개 게시글 데이터 */
  const { data: counselPostData } = useQuery(
    [PARENTING_INFO_COUNSEL_RECENT, range],
    async () => {
      const result = await request<ResponseType<ParentingCounselType[]>>({
        method: "GET",
        url: `/community/parenting-info/counsel/popular?range=${range}`,
      });

      return result.data;
    },
    {
      onError: (error) => {
        console.error("Query Error:", error);
      },
    }
  );

  /** ============================= 비즈니스 로직 영역 ============================= */

  /** ============================= 컴포넌트 영역 ============================= */

  /** ============================= useEffect 영역 ============================= */

  useEffect(() => {
    const profileId = localStorage.getItem("ggp_profileId");
    const age = localStorage.getItem("age");

    if (profileId && age) {
      diagnosticMainData({ profileId, age });
    }
  }, [localStorage.getItem("ggp_profileId")]);

  return (
    <MainTemplate>
      <>
        <MainBanner selectedProfile={selectedProfile} />
        <ContentSection>
          <>
            <ContentBox
              title="이런 진단테스트는 어때요?"
              onClick={() => {
                navigate("/test/list");
                navigate("/auth/profile/select");
              }}
            >
              <List overflowX={true}>
                {diagnosticData?.length ? (
                  diagnosticData?.map((item: any, idx: number) => {
                    return <TestItem data={item} key={idx} />;
                  })
                ) : (
                  <EmptyMessage>
                    우리 아이 프로필을 추가하여
                    <br />
                    진단테스트를 시작해 보세요.
                  </EmptyMessage>
                )}
              </List>
            </ContentBox>

            <ContentBox
              title="커뮤니티 인기글"
              // sectionLink="/community/info/board"
            >
              <MainPostTab onTabChange={setRange}>
                <List direction="column" gap={10}>
                  {counselPostData?.length ? (
                    counselPostData.map((item: any, idx: number) => {
                      return <MainPostItem data={item} key={idx} />;
                    })
                  ) : (
                    <EmptyMessage>
                      {range === "today" && "오늘의 인기글이 없습니다."}
                      {range === "week" && "이번 주 인기글이 없습니다."}
                      {range === "month" && "이번 달 인기글이 없습니다."}
                    </EmptyMessage>
                  )}
                </List>
              </MainPostTab>
            </ContentBox>

            <ImgBanner height={130} img={ImgBottom} />
          </>
        </ContentSection>
      </>
    </MainTemplate>
  );
};

interface EmptyMessageProps {
  children: React.ReactNode;
}

export const EmptyMessage = ({ children }: EmptyMessageProps) => {
  return (
    <div
      style={{
        padding: "30px 0",
        textAlign: "center",
        color: "#666",
        fontSize: "15px",
        fontWeight: "300",
        fontFamily: "Pretendard",
        lineHeight: "140%",
        backgroundColor: "#f8f8f8",
        borderRadius: "8px",
        margin: "10px 0",
        width: "100%",
      }}
    >
      {children}
    </div>
  );
};
